import script from "./BindPhoneDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BindPhoneDialog.vue?vue&type=script&setup=true&lang=js"

import "./BindPhoneDialog.vue?vue&type=style&index=0&id=0d16496b&lang=css"

const __exports__ = script;

export default __exports__